import React, { useState } from 'react';
import { BRAND } from './brand';

/** VK Tours logo image; falls back to a text wordmark if the image can't load. */
const Logo = ({ width, height }) => {
  const [failed, setFailed] = useState(false);
  if (failed) return <span className="vk-logo-text">VK <span>Tours</span></span>;
  return <img src={BRAND.logo} alt="VK Tours" width={width} height={height} onError={() => setFailed(true)} />;
};

export default Logo;
